import { styled } from '@mui/material/styles';
import { FormHTMLAttributes } from 'react';
import { Box, BoxProps } from '@mui/material';
import login_bg from 'assets/img/login_bg.png';
import { primary } from 'assets/colors/colors';

export const Container = styled(Box)<BoxProps>(() => ({
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundImage: `url(${login_bg})`,
}));

export const StyledForm = styled(
  (props: FormHTMLAttributes<HTMLFormElement>) => <form {...props} />,
)(() => ({
  background: primary.contrastText,
  borderRadius: '8px',
  padding: '2rem',
}));
